import { Button, Group, Paper, Text } from '@mantine/core'
import { isEmpty } from 'lodash'
import React, { ReactElement, useEffect } from 'react'

import Field from '../../../../../../../../../../1stlog-ui/src/components/Field'
import useFieldState from '../../../../../../../../../../1stlog-ui/src/components/Field/useFieldState'
import TimePicker from '../../../../../../../../../../1stlog-ui/src/components/TimePicker'
import { useDeliveryProduct } from '../../../../../../../Products'
import { RecommendedTimeValidation } from './RecommendedTimeValidation'

type RecommendedTimePickerProps = {}

export const RecommendedTimePicker = (
  props: RecommendedTimePickerProps,
): ReactElement => {
  const {} = props

  const { recommendedTimesMayBeSet } = useDeliveryProduct() || {}

  const [recommendedTimeFrom, setRecommendedTimeFrom] = useFieldState<string>(
    'recommendedTimeFrom',
  )
  const [recommendedTimeUntil, setRecommendedTimeUntil] = useFieldState<string>(
    'recommendedTimeUntil',
  )
  const [recommendedTimeFromCache, setRecommendedTimeFromCache] =
    useFieldState<string>('recommendedTimeFromCache')
  const [recommendedTimeUntilCache, setRecommendedTimeUntilCache] =
    useFieldState<string>('recommendedTimeUntilCache')

  // const { meta: recommendedTimeFromValidation } = useField(
  //   'recommendedTimeFromValidation',
  //   {
  //     validate: (value) => {
  //       console.log('validate recommendedTimeFromValidation', value)
  //     },
  //     raw: true,
  //     subscribeAll: true,
  //   },
  // )

  // console.log('recommendedTimeFromValidation', recommendedTimeFromValidation)

  // Cache recommended times
  useEffect(() => {
    setRecommendedTimeFromCache(recommendedTimeFrom)
  }, [recommendedTimeFrom])
  useEffect(() => {
    setRecommendedTimeUntilCache(recommendedTimeUntil)
  }, [recommendedTimeUntil])

  // Restore cache
  useEffect(() => {
    setTimeout(() => {
      setRecommendedTimeFrom(recommendedTimeFromCache || '8:00')
      setRecommendedTimeUntil(recommendedTimeUntilCache || '17:00')
    }, 0)
  }, [])

  const setFrom = (): void => {
    setRecommendedTimeFrom('10:00')
  }

  const setUntil = (): void => {
    // setTimeout(() => {
    setRecommendedTimeUntil('14:00')
    // }, 0)
  }

  // const clearFrom = (): void => {
  //   setRecommendedTimeFrom(null)
  // }

  // const clearUntil = (): void => {
  //   setRecommendedTimeUntil(null)
  // }

  if (!recommendedTimesMayBeSet) {
    return <></>
  }

  return (
    <>
      <div>
        <div className="mt-0">{i18n.t('recommended_time', 'Hinweiszeit')}:</div>
        <div>
          <Group spacing="sm" align="center" noWrap>
            <Paper withBorder={false} p={0}>
              <Group spacing={5} align="center" noWrap>
                {isEmpty(recommendedTimeFrom) ? (
                  <Button variant="light" size="sm" onClick={setFrom}>
                    {i18n.t('add_start_time', 'Startzeit hinzufügen')}
                  </Button>
                ) : (
                  <>
                    {isEmpty(recommendedTimeUntil) &&
                      !isEmpty(recommendedTimeFrom) && (
                        <Text color="grey">{i18n.t('capital_from', 'Ab')}</Text>
                      )}
                    <Field name="recommendedTimeFrom" noMargin>
                      <TimePicker />
                    </Field>
                    {/* <div>
                      <Tooltip
                        label={i18n.t('clear_start_time', 'Startzeit löschen')}
                      >
                        <ActionIcon onClick={clearFrom} variant="subtle">
                          <FontAwesomeIcon icon={faTrash} />
                        </ActionIcon>
                      </Tooltip>
                    </div> */}
                  </>
                )}
              </Group>
            </Paper>

            {((isEmpty(recommendedTimeFrom) && isEmpty(recommendedTimeUntil)) ||
              (!isEmpty(recommendedTimeFrom) &&
                !isEmpty(recommendedTimeUntil))) && <Text>-</Text>}

            <Paper withBorder={false} p={5}>
              <Group spacing={5} align="center" noWrap>
                {isEmpty(recommendedTimeUntil) ? (
                  <Button variant="light" size="sm" onClick={setUntil}>
                    {i18n.t('add_end_time', 'Endzeit hinzufügen')}
                  </Button>
                ) : (
                  <>
                    {isEmpty(recommendedTimeFrom) &&
                      !isEmpty(recommendedTimeUntil) && (
                        <Text color="grey">
                          {i18n.t('capital_until', 'Bis')}
                        </Text>
                      )}
                    <Field name="recommendedTimeUntil">
                      <TimePicker />
                    </Field>
                    {/* <div>
                      <Tooltip
                        label={i18n.t('clear_end_time', 'Endzeit löschen')}
                      >
                        <ActionIcon
                          onClick={clearUntil}
                          variant="subtle"
                          size="xs"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </ActionIcon>
                      </Tooltip>
                    </div> */}
                  </>
                )}
              </Group>
            </Paper>
          </Group>
        </div>
        {recommendedTimesMayBeSet && <RecommendedTimeValidation />}
      </div>
    </>
  )
}
